// Only catches typos. The API validates the address properly (class-validator
// `@IsEmail`), so a stricter pattern here only locks out real mailboxes.
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// An address never contains whitespace; phone keyboards and autofill add it anyway.
export const normalizeEmail = (value: string): string => value.replace(/\s+/g, "");

// Eight characters or more with at least one digit.
export const passwordRegex = /^(?=.*\d)[A-Za-z\d@$!%*#?&-_+=/\\.,():;~]{8,}$/;
